import type { Cell, ColumnMeta } from '@tanstack/react-table';
import { flexRender } from '@tanstack/react-table';
import { twMerge } from 'tailwind-merge';
import { TableElement } from '../../types';
import { TABLE_CELL_STYLES } from './styles';

type TableCellProps<T extends TableElement> = {
  cell: Cell<T, unknown>;
  className?: string;
};

export const TableCell = <T extends TableElement>({ cell, className }: TableCellProps<T>) => {
  const meta = cell.column.columnDef.meta as ColumnMeta<T, unknown>;

  const cellType = typeof cell.getValue();

  const columnDefCell =
    typeof cell.column.columnDef.cell === 'function'
      ? (cell.column.columnDef.cell?.(cell.getContext()) as string | number | undefined)
      : cell.column.columnDef.cell;
  const cellValue = typeof columnDefCell === 'string' || typeof columnDefCell === 'number' ? columnDefCell : null;

  return (
    <td
      key={cell.id}
      align={meta?.align}
      className={twMerge(TABLE_CELL_STYLES, className, meta?.className?.(cell.getContext()))}
      style={{
        maxWidth: cell.column.columnDef.maxSize,
        minWidth: cell.column.columnDef.minSize,
        width: cell.column.columnDef.size,
      }}
    >
      <div
        title={cellValue?.toString()}
        className={twMerge('w-fit max-w-full', cellType === 'string' ? 'truncate' : undefined, meta?.nestedClassName?.(cell.getContext()))}
      >
        {flexRender(cell.column.columnDef.cell, cell.getContext())}
      </div>
    </td>
  );
};
